import { useAppSelector } from "integrations/redux/hooks"
import { VideoContainer } from "./VideoContainer"
import { selectOpenVideoFlights } from "../state/selectors"

export const VideoProvider = () => {
    const openVideoFlightIds = useAppSelector(selectOpenVideoFlights)
    return (
        <div className="flex flex-col">
            {openVideoFlightIds.toSorted().map((id) => (
                <div
                    key={id}
                    style={{
                        zIndex: openVideoFlightIds.findIndex((flightId) => flightId === id),
                    }}
                >
                    <VideoContainer flightId={id} />
                </div>
            ))}
        </div>
    )
}
